import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { clearInternalSchedulesTxnErrors } from "../../../../redux/features/scheduleInternalTxn";
import TabsWeapperSection from "../../../_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import "./index.css";

const ScheduleInternalTransactionMultiError = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { schedulesInternalTxnRejectError, schedulesInternalTxnApproveError } =
    useSelector((state) => state.scheduleInternalTxnSlice);

  const actionType =
    schedulesInternalTxnRejectError && !schedulesInternalTxnApproveError
      ? "reject"
      : schedulesInternalTxnApproveError && !schedulesInternalTxnRejectError
        ? "approve"
        : "approve";
  const [ErrorPageData, setErrorPageData] = useState([]);

  const findCommonNames = (arr1, arr2) => {
    let type = arr2.some((item) => typeof item === "string");
    if (type) {
      return arr2;
    } else {
      const arr2Map = new Map(arr2?.map((item) => [item?.id, item?.errors]));

      return arr1
        ?.filter((item) => arr2Map?.has(item.txn_id))
        .map((item) => ({
          ...item,
          errors: arr2Map?.get(item.txn_id),
        }));
    }
  };

  const filterErrorTxn = findCommonNames(
    ErrorPageData,
    JSON.parse(sessionStorage.getItem("ScheduleInternalMultiDataError")) || [],
  );

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("intSelectedScheduleCard"),
    );

    if (storedSelectedApproval) {
      setErrorPageData(storedSelectedApproval?.[0]?.selectedDetails);
    } else {
      setErrorPageData([]);
    }

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
      dispatch(clearInternalSchedulesTxnErrors());
    };
  }, [dispatch]);

  const buttonRows = [
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
        handleFunction: () => navigate("/internal_transaction_dashboard"),
      },
    ],
  ];

  const getTitle = () => {
    return actionType === "reject"
      ? "Oops! Schedules rejection failed"
      : "Oops! Schedules approval failed";
  };

  const getSubtitle = () => {
    const action = actionType === "reject" ? "rejection" : "approval";
    return `An error occurred with the following schedules, causing the ${action} of all the schedules to fail.`;
  };

  return (
    <div>
      <StatusContainer
        status="error"
        buttonRows={buttonRows}
        title={getTitle()}
        subtitle={getSubtitle()}
      >
        <>
          <TabsWeapperSection title="Error details">
            {Array.isArray(filterErrorTxn) &&
              filterErrorTxn.map((val, i) => {
                if (
                  typeof val === "string" &&
                  val.includes("No transactions found for transaction ids")
                ) {
                  return (
                    <InfoCard
                      key={i}
                      bgColor="var(--negative-card)"
                      rows={[
                        {
                          leftTitle: val,
                          leftSubTitle: "Error message",
                        },
                      ]}
                    />
                  );
                }

                return val?.errors ? (
                  val.errors.map((error, index) => (
                    <InfoCard
                      key={`${val.txn_id || i}-${index}`}
                      bgColor="var(--negative-card)"
                      rows={[
                        {
                          leftTitle: error?.reason || error,
                          leftSubTitle: "Error message",
                        },
                      ]}
                    />
                  ))
                ) : (
                  <InfoCard
                    key={val.txn_id || i}
                    bgColor="var(--negative-card)"
                    rows={[
                      {
                        leftTitle: "No specific error details found.",
                        leftSubTitle: "Error message",
                      },
                    ]}
                  />
                );
              })}
          </TabsWeapperSection>

          <TabsWeapperSection title="Schedules Details">
            {Array.isArray(ErrorPageData) &&
              ErrorPageData.map((val, i) => {
                if (!val?.txn_id) return null;

                return (
                  <InfoCard
                    key={val.txn_id || i}
                    bgColor="var(--negative-card)"
                    hoverable="white"
                    onClick={() =>
                      navigate(
                        `/internal_transaction_dashboard/schedule_view_all/schedule_detail_page/${val?.txn_id}`,
                      )
                    }
                    rows={[
                      {
                        leftTitle: val.scheduled_name,
                        leftSubTitle: "Schedule name",
                        hasRight: true,
                        rightText: true,
                        rightTitleTextColor: "var(--text-primary)",
                        rightTitle: (
                          <>
                            INR <FormatAmount price={val?.amount} />
                          </>
                        ),
                        rightTextFontWeight: "semibold",
                        rightSubTitle: "Amount",
                        rightIcon: true,
                      },
                    ]}
                  />
                );
              })}
          </TabsWeapperSection>
        </>
      </StatusContainer>
    </div>
  );
};

export default ScheduleInternalTransactionMultiError;
